import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {AiOutlineEye, AiOutlineSearch} from 'react-icons/ai';
import Pagination from '../Utils/Pagination';
import axios from 'axios';
import {asset, authUser, axiosConfig, formatDate, isAdmin, translateToBanglaDigit, url} from "../../helpers/helpers";
import {toast, ToastContainer} from "react-toastify";
import Select2Wrapper from "../Utils/Select2Wrapper";
import {FiRefreshCw} from "react-icons/fi";
import Loader from "../Loader/Loader";
import avatar from "../../Assets/avatar.png"

const UpdatedEmployeeData = (
    {
        data,
        setData,
        currentPage,
        totalPages,
        setCurrentPage,
        handlePageChange,
        designation,
        setDesignation,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        ministry,
        setMinistry,
        organization,
        setOrganization,
        institution,
        setInstitution,
        perPage,
        setPerPage,
        permissions,
        isSearching,
    }
) => {
    const navigate = useNavigate();
    const [designations, setDesignations] = useState([]);
    const [institutions, setInstitutions] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [ministryOrganizationAndInstitution, setMinistryOrganizationAndInstitution] = useState([]);
    const [isPrinting, setIsPrinting] = useState(false);
    const promiseResolveRef = useRef(null);

    const getDesignation = () => {
        try {
            axios.get(url(`fetch-designation`), {
                ...axiosConfig(), params: {
                    ministry,
                    organization,
                    institution
                }
            })
                .then(({data: {data}}) => {
                    setDesignations(data)
                })
                .catch((error) => {
                    console.log(error);
                })
        } catch (e) {
            toast.error('something went wrong')
        }
    }

    const getMinistryOrganizationAndInstitution = () => {
        try {
            axios.get(url(`fetch-ministry-organization-and-institution-user-wise`), axiosConfig())
                .then(({data: {data}}) => {
                    setMinistryOrganizationAndInstitution(data);
                })
                .catch((error) => {
                    console.log(error);
                })
        } catch (e) {
            toast.error('something went wrong')
        }
    }

    const handleMinistryChange = (id) => {
        let org = ministryOrganizationAndInstitution.filter(data => data.parent_id == id && data.type === 'organization');
        setOrganizations(org);
        setMinistry(id);
    }
    const handleOrganizationChange = (id) => {
        let institute = ministryOrganizationAndInstitution.filter(data => data.parent_id == id && data.type === 'institution');
        setInstitutions(institute);
        setOrganization(id);
    }
   
    const onError = ({ currentTarget }) => {
        currentTarget.onError = null;
        currentTarget.src= avatar
    }
    const handleSearchButtonClick = () => {
        handlePageChange();
    }
    const handleRefreshButtonClick = () => {
        toast.success("রিফ্রেশ করা হয়েছে");
        window.location.reload();
    }
    useEffect(() => {
        if (ministry && organization) {
            getDesignation();
        }
    }, [ministry, organization]);

    useEffect(() => {
        if (isPrinting && promiseResolveRef.current) {
            promiseResolveRef.current();
        }
    }, [isPrinting])

    useEffect(() => {
        handleMinistryChange(authUser()?.ministry_id);
        if (!isAdmin() && ministryOrganizationAndInstitution) {
            handleOrganizationChange(authUser()?.organization_id);
        }
    }, [ministryOrganizationAndInstitution]);

    useEffect(() => {
        getMinistryOrganizationAndInstitution();
    }, []);

    return (
        <div>
            <div style={{display: isSearching ? "block" : "none"}}>
                <Loader/>
            </div>
            <ToastContainer/>
            <div className="card" style={{display: isSearching ? "none" : "block"}}>
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-3">
                            <select
                                className="form-select" value={ministry}
                                onChange={(e) => handleMinistryChange(e.target.value)}
                            >
                                <option value="" style={{color: 'gray'}}>মন্ত্রণালয় নির্বাচন করুন</option>
                                {ministryOrganizationAndInstitution && ministryOrganizationAndInstitution.map(ministry => {
                                    return ministry.parent_id === null ? (<option key={ministry.id} value={ministry.id}>
                                        {ministry.name}
                                    </option>) : '';
                                })}
                            </select>
                        </div>
                        <div className="col-3">
                            <select
                                className="form-select" value={organization}
                                onChange={(e) => handleOrganizationChange(e.target.value)}
                            >
                                <option value="" style={{color: 'gray'}}>দপ্তর /সংস্থা নির্বাচন করুন</option>
                                {organizations && organizations.map(org => {
                                    return (<option key={org.id} value={org.id}>
                                        {org.name}
                                    </option>);
                                })}
                            </select>
                        </div>
                        <div className="col-3">
                            <Select2Wrapper
                                value={institution}
                                placeholder="প্রতিষ্ঠান নির্বাচন করুন"
                                onChange={(value) => setInstitution(value)}
                                options={institutions}
                            />
                        </div>
                        <div className="col-3">
                            <Select2Wrapper
                                value={designation}
                                placeholder="পদবি নির্বাচন করুন"
                                onChange={(value) => setDesignation(value)}
                                options={designations}
                            />
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className="col-3">
                            <input type="date" className="form-control"
                                   value={startDate}
                                   onChange={(event) => setStartDate(event.target.value) }
                            />
                        </div>
                        <div className="col-3">
                            <input type="date" className="form-control"
                                value={endDate}
                                onChange={(event) => setEndDate(event.target.value) }
                            />
                        </div>
                        <div className="col-3" style={{textAlign: 'left'}}>
                            <button
                                onClick={handleSearchButtonClick}
                                type="submit"
                                style={{marginRight: '10px'}}
                                disabled={isSearching}
                                className="btn btn-sm btn-success mt-1">
                                <AiOutlineSearch/> Search
                            </button>
                            <button
                                onClick={handleRefreshButtonClick}
                                type="submit"
                                disabled={isSearching}
                                className="btn btn-sm btn-warning mt-1">
                                <FiRefreshCw/> Refresh
                            </button>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-1">
                            <select className="form-select"
                                    value={perPage}
                                    onChange={(e) => setPerPage(e.target.value)}>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-12">
                            <div className='table-responsive'>
                                <table className="table table-bordered table-hover">
                                    <thead>
                                    <tr style={{backgroundColor: '#f9f9f9'}}>
                                        <th className="text-center" scope="col">ক্রমিক নং</th>
                                        <th scope="col" className='text-center'>ছবি</th>
                                        <th scope="col">নাম</th>
                                        <th scope="col">আইডি</th>
                                        <th scope="col">মোবাইল নং</th>
                                        <th scope="col">পদবি</th>
                                        <th scope="col">মন্ত্রণালয়,দপ্তর /সংস্থা, বর্তমান কর্মস্থল</th>
                                        <th scope="col">যোগদানের তারিখ</th>
                                        <th scope="col">সর্বশেষ হালনাগাদ</th>
                                        <th scope="col">অ্যাকশন</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data && data.data.map((user, key) => {
                                        return (<tr key={user?.id}>
                                            <td className="text-center" style={{verticalAlign: 'center'}}>{translateToBanglaDigit(data.from + key)}</td>
                                            <td style={{textAlign: 'center'}}>
                                                <img onError={onError} style={{width: '80px', height: '80px', border: '2px solid gray', borderRadius: '50px'}} src={user?.image ? asset(user.image) : avatar } />
                                            </td>
                                            <td style={{verticalAlign: 'center'}}>{user?.name_in_bn}</td>
                                            <td style={{verticalAlign: 'center'}}>{user?.unique_id}</td>
                                            <td style={{verticalAlign: 'center'}}>{translateToBanglaDigit(user?.phone)}</td>
                                            <td style={{verticalAlign: 'center'}}>{user?.designation}</td>
                                            <td style={{verticalAlign: 'center'}}>
                                                {
                                                    user?.min_org_ins
                                                }
                                            </td>
                                            <td style={{verticalAlign: 'center'}}>{translateToBanglaDigit(formatDate(user?.joining_date))}</td>
                                            <td style={{ verticalAlign: 'middle' }}>
                                                {translateToBanglaDigit(formatDate(user?.updated_at))}
                                                <br />
                                                {translateToBanglaDigit(user?.updated_at_time)}
                                            </td>
                                            <td style={{verticalAlign: 'center'}}>
                                                <div>
                                                    {
                                                        (isAdmin() || permissions?.includes('view')) &&
                                                        <button className="btn btn-sm btn-info mt-1"
                                                                title="ভিউ করুন"
                                                                onClick={() => navigate(`/updated-employee-data/${user.id}/view-full`)}>
                                                            <AiOutlineEye/>
                                                        </button>
                                                    }
                                                </div>
                                            </td>
                                        </tr>)
                                    })}
                                    </tbody>
                                </table>
                            </div>
                            <br></br>
                            {
                                !isSearching && <Pagination currentPage={currentPage} totalPages={totalPages}
                                                                onPageChange={setCurrentPage} firstAndLastPageShow={true}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>);
};

export default UpdatedEmployeeData;